var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TablePagination = void 0;
var TablePagination_1 = __importDefault(require("./TablePagination"));
exports.TablePagination = TablePagination_1.default;
exports.default = TablePagination_1.default;
//# sourceMappingURL=index.js.map